export enum ProjectNameType {
  NUNUNU = 'NUNUNU',
  AHAVA = 'AHAVA',
  FULLRAVEN = 'FULLRAVEN',
  ORLO = 'ORLO',
}
